import getActiveDrawerPane from "../selectors/getActiveDrawerPane";
import getTabIdFromWindow from "./getTabIdFromWindow";

/**
 * Returns the pane ID of the currently-shown drawer pane for the given window,
 * or `undefined` if no pane is shown.
 *
 * This is a convenience wrapper that resolves the window's tab ID internally,
 * so callers don't need to import `getTabIdFromWindow` or `getActiveDrawerPane`
 * separately.
 *
 * @param targetWindow - The window context (defaults to the main window).
 */
export default function getActiveDrawerPaneId(targetWindow?: Window): string | undefined {
    const tabId = getTabIdFromWindow(targetWindow);
    return getActiveDrawerPane(tabId);
}
